import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CatalogItemMultiEdit = () => {
  return (
    <MicroFrontEnd
      name="CatalogItemMultiEdit"
      src={apiConfig.microFrontEnds.CatalogItemMultiEdit}
    />
  )
}

export default CatalogItemMultiEdit
